import React, { useEffect, useState } from 'react';
import api from '../api';

const styles = {
  container: {
    maxWidth: 480,
    margin: '0 auto',
    background: '#fff',
    minHeight: '100vh',
    paddingBottom: 100,
  },
  header: {
    padding: '1.25rem',
    borderBottom: '1px solid #f0f0f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 10,
  },
  backBtn: {
    border: 'none',
    background: 'none',
    fontSize: 15,
    color: '#888',
    padding: 0,
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 600,
  },
  statsBar: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 8,
    padding: '0.75rem 1.25rem',
    borderBottom: '1px solid #f0f0f0',
  },
  statBox: {
    background: '#f8f8f8',
    borderRadius: 8,
    padding: '8px 10px',
  },
  statLabel: {
    fontSize: 10,
    color: '#888',
    marginBottom: 2,
  },
  statValue: {
    fontSize: 14,
    fontWeight: 600,
  },
  exerciseList: {
    padding: '0.75rem 1.25rem',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  exerciseCard: {
    border: '1px solid #ebebeb',
    borderRadius: 12,
    overflow: 'hidden',
  },
  exerciseHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 12px',
    background: '#f8f8f8',
  },
  exerciseName: {
    fontSize: 14,
    fontWeight: 600,
  },
  setCount: {
    fontSize: 12,
    color: '#888',
  },
  colHeaders: {
    display: 'grid',
    gridTemplateColumns: '28px 1fr 1fr 60px',
    padding: '4px 12px',
    background: '#fff',
  },
  colLabel: {
    fontSize: 11,
    color: '#aaa',
    textAlign: 'center',
  },
  setRow: {
    display: 'grid',
    gridTemplateColumns: '28px 1fr 1fr 60px',
    alignItems: 'center',
    padding: '5px 12px',
    borderTop: '1px solid #f5f5f5',
    gap: 4,
  },
  setNum: {
    fontSize: 12,
    color: '#aaa',
  },
  setInput: {
    border: '1px solid #ebebeb',
    borderRadius: 6,
    padding: '5px 4px',
    fontSize: 13,
    textAlign: 'center',
    width: '85%',
    margin: '0 auto',
    display: 'block',
    background: '#fff',
  },
  setVol: {
    fontSize: 12,
    color: '#aaa',
    textAlign: 'center',
  },
  addSetBtn: {
    display: 'block',
    width: 'calc(100% - 24px)',
    margin: '8px 12px',
    padding: '6px',
    fontSize: 12,
    color: '#888',
    background: 'transparent',
    border: '1px dashed #ddd',
    borderRadius: 8,
    textAlign: 'center',
  },
  bodyMassRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '0.75rem 1.25rem',
    borderTop: '1px solid #f0f0f0',
    marginTop: 4,
  },
  bodyMassLabel: {
    fontSize: 13,
    color: '#888',
    flex: 1,
  },
  bodyMassInput: {
    border: '1px solid #ebebeb',
    borderRadius: 8,
    padding: '6px 10px',
    fontSize: 14,
    width: 80,
    textAlign: 'center',
  },
  bodyMassUnit: {
    fontSize: 13,
    color: '#aaa',
  },
  addExerciseBtn: {
    display: 'block',
    width: 'calc(100% - 2.5rem)',
    margin: '0 1.25rem',
    padding: '12px',
    fontSize: 14,
    color: '#888',
    background: 'transparent',
    border: '1px dashed #ddd',
    borderRadius: 12,
    textAlign: 'center',
  },
  saveBtn: {
    display: 'block',
    width: 'calc(100% - 2.5rem)',
    margin: '12px 1.25rem 0',
    padding: '14px',
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
    background: '#1a1a1a',
    border: 'none',
    borderRadius: 12,
    textAlign: 'center',
  },
  modal: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: 100,
  },
  modalSheet: {
    background: '#fff',
    width: '100%',
    maxWidth: 480,
    borderRadius: '16px 16px 0 0',
    padding: '1.5rem 1.25rem 2rem',
  },
  modalTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: '1rem',
  },
  modalInput: {
    width: '100%',
    padding: '12px',
    border: '1px solid #ebebeb',
    borderRadius: 10,
    fontSize: 15,
    marginBottom: 10,
  },
  modalBtn: {
    display: 'block',
    width: '100%',
    padding: '14px',
    marginBottom: 8,
    border: '1px solid #ebebeb',
    borderRadius: 10,
    background: '#fff',
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'center',
  },
  modalCancelBtn: {
    display: 'block',
    width: '100%',
    padding: '14px',
    border: 'none',
    borderRadius: 10,
    background: '#f5f5f5',
    fontSize: 14,
    color: '#888',
    textAlign: 'center',
  },
};

export default function WorkoutScreen({ session, onEndWorkout }) {
  const [exercises, setExercises] = useState([]);
  const [setData, setSetData] = useState({});
  const [bodyMass, setBodyMass] = useState('');
  const [showAddExercise, setShowAddExercise] = useState(false);
  const [newExerciseName, setNewExerciseName] = useState('');
  const [saving, setSaving] = useState(false);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const startTimeRef = React.useRef(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsedSeconds(Math.floor((Date.now() - startTimeRef.current) / 1000));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (secs) => {
    const m = Math.floor(secs / 60).toString().padStart(2, '0');
    const s = (secs % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  useEffect(() => {
    api.get(`/exercises/${session.workout_type_id}`).then(r => {
      setExercises(r.data);
      const initial = {};
      r.data.forEach(ex => {
        initial[ex.id] = [{ weight: '', reps: '' }];
      });
      setSetData(initial);
    });
  }, [session.workout_type_id]);

  const updateSet = (exerciseId, setIndex, field, value) => {
    setSetData(prev => {
      const updated = { ...prev };
      updated[exerciseId] = [...updated[exerciseId]];
      updated[exerciseId][setIndex] = { ...updated[exerciseId][setIndex], [field]: value };
      return updated;
    });
  };

  const addSet = (exerciseId) => {
    setSetData(prev => {
      const current = prev[exerciseId] || [];
      if (current.length >= 5) return prev;
      return { ...prev, [exerciseId]: [...current, { weight: '', reps: '' }] };
    });
  };

  const getVol = (weight, reps) => {
    const w = parseFloat(weight);
    const r = parseInt(reps);
    if (!isNaN(w) && !isNaN(r) && r > 0) return (w * r).toFixed(0);
    return '—';
  };

  const handleAddExercise = async () => {
    if (!newExerciseName.trim()) return;
    const res = await api.post('/exercises', {
      name: newExerciseName.trim(),
      workout_type_id: session.workout_type_id,
    });
    const newEx = res.data;
    setExercises(prev => [...prev, newEx]);
    setSetData(prev => ({ ...prev, [newEx.id]: [{ weight: '', reps: '' }] }));
    setNewExerciseName('');
    setShowAddExercise(false);
  };

  const handleSave = async () => {
    setSaving(true);

    for (const ex of exercises) {
      const sets = setData[ex.id] || [];
      for (let i = 0; i < sets.length; i++) {
        const { weight, reps } = sets[i];
        const w = parseFloat(weight);
        const r = parseInt(reps);
        if (!isNaN(w) && !isNaN(r) && r > 0) {
          await api.post(`/sessions/${session.id}/sets`, {
            exercise_id: ex.id,
            set_number: i + 1,
            weight: w,
            reps: r,
          });
        }
      }
    }

    await api.patch(`/sessions/${session.id}`, {
      ...(bodyMass && { body_mass: parseFloat(bodyMass) }),
      duration_seconds: elapsedSeconds,
    });


    setSaving(false);
    onEndWorkout();
  };

  // Live stats from current inputs
  const liveStats = React.useMemo(() => {
    let weight = 0;
    let reps = 0;
    exercises.forEach(ex => {
      (setData[ex.id] || []).forEach(s => {
        const w = parseFloat(s.weight);
        const r = parseInt(s.reps);
        if (!isNaN(w) && !isNaN(r) && r > 0) {
          weight += w * r;
          reps += r;
        }
      });
    });
    return {
      total_weight: weight,
      total_reps: reps,
      avg_per_rep: reps > 0 ? (weight / reps).toFixed(1) : 0,
    };
  }, [setData, exercises]);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onEndWorkout}>← Back</button>
        <span style={styles.headerTitle}>{session.workout_type_name} Day</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', fontVariantNumeric: 'tabular-nums' }}>
          {formatTime(elapsedSeconds)}
        </span>
      </div>

      <div style={styles.statsBar}>
        <div style={styles.statBox}>
          <div style={styles.statLabel}>Total weight</div>
          <div style={styles.statValue}>{liveStats.total_weight.toLocaleString()} lbs</div>
        </div>
        <div style={styles.statBox}>
          <div style={styles.statLabel}>Total reps</div>
          <div style={styles.statValue}>{liveStats.total_reps}</div>
        </div>
        <div style={styles.statBox}>
          <div style={styles.statLabel}>Avg / rep</div>
          <div style={styles.statValue}>{liveStats.avg_per_rep} lbs</div>
        </div>
      </div>

      <div style={styles.exerciseList}>
        {exercises.map(ex => (
          <div key={ex.id} style={styles.exerciseCard}>
            <div style={styles.exerciseHeader}>
              <span style={styles.exerciseName}>{ex.name}</span>
              <span style={styles.setCount}>{(setData[ex.id] || []).length} sets</span>
            </div>
            <div style={styles.colHeaders}>
              <span style={{ ...styles.colLabel, textAlign: 'left' }}>Set</span>
              <span style={styles.colLabel}>Weight</span>
              <span style={styles.colLabel}>Reps</span>
              <span style={styles.colLabel}>Vol</span>
            </div>
            {(setData[ex.id] || []).map((s, i) => (
              <div key={i} style={styles.setRow}>
                <span style={styles.setNum}>{i + 1}</span>
                <input
                  style={styles.setInput}
                  placeholder="lbs"
                  value={s.weight}
                  onChange={e => updateSet(ex.id, i, 'weight', e.target.value)}
                  type="number"
                />
                <input
                  style={styles.setInput}
                  placeholder="reps"
                  value={s.reps}
                  onChange={e => updateSet(ex.id, i, 'reps', e.target.value)}
                  type="number"
                />
                <span style={styles.setVol}>{getVol(s.weight, s.reps)}</span>
              </div>
            ))}
            {(setData[ex.id] || []).length < 5 && (
              <button style={styles.addSetBtn} onClick={() => addSet(ex.id)}>
                + add set
              </button>
            )}
          </div>
        ))}
      </div>

      <button style={styles.addExerciseBtn} onClick={() => setShowAddExercise(true)}>
        + add custom exercise
      </button>

      <div style={styles.bodyMassRow}>
        <span style={styles.bodyMassLabel}>Body mass</span>
        <input
          style={styles.bodyMassInput}
          placeholder="—"
          value={bodyMass}
          onChange={e => setBodyMass(e.target.value)}
          type="number"
        />
        <span style={styles.bodyMassUnit}>lbs</span>
      </div>

      <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
        {saving ? 'Saving...' : 'End Workout'}
      </button>

      {showAddExercise && (
        <div style={styles.modal} onClick={() => setShowAddExercise(false)}>
          <div style={styles.modalSheet} onClick={e => e.stopPropagation()}>
            <div style={styles.modalTitle}>Add custom exercise</div>
            <input
              style={styles.modalInput}
              placeholder="Exercise name"
              value={newExerciseName}
              onChange={e => setNewExerciseName(e.target.value)}
              autoFocus
            />
            <button style={styles.modalBtn} onClick={handleAddExercise}>
              Add to this workout
            </button>
            <button style={styles.modalCancelBtn} onClick={() => setShowAddExercise(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}